import Segment, { SegmentContainer } from "components/atoms/Segment";
import AdminConsoleHeader from "components/molecules/AdminConsoleHeader";
import AdminConsoleJobs from "containers/AdminConsoleJobs";
import AdminConsoleTenants from "containers/AdminConsoleTenants";

const AdminConsole = () => {
    return (
        <SegmentContainer>
            <AdminConsoleHeader></AdminConsoleHeader>
            <Segment shadow>
                <AdminConsoleTenants></AdminConsoleTenants>
            </Segment>
            <Segment shadow>
                <AdminConsoleJobs></AdminConsoleJobs>
            </Segment>
        </SegmentContainer>
    );
};

export default AdminConsole;
